import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { Data, Variables } from './types'

export const GET_AD_UNIT_AMAZON_ALERTS: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}

  query adUnitAmazonAlerts($id: ID!) {
    node(id: $id) {
      ... on AdUnitAmazon {
        fieldAlerts {
          ...AlertFragment
        }
      }
    }
  }
`
